<template>
    <div>
        <Conten0 />
        <Conten1 />
    </div>
</template>
<script>
import Conten0 from "./Content0";
import Conten1 from "./Content1";
import initAnimation from "../animation"
export default {
    components: {
        Conten0,
        Conten1,
    },
    mounted(){
        setTimeout(initAnimation,0);
    },
};
</script>



// WEBPACK FOOTER //
// src/Pages/CloudSaasAccerlation/CloudSaasAccerlation.vue